module.exports = __webpack_public_path__ + "img/ok-button.b17bc383.svg";